import type { CspV2Gate, CsmBookOfBusiness, CsmCatalogSignal } from '@/types/csm';
import type { AssigneesListResponse } from '@/types/users';
import api, { API_PREFIX } from './api';

export const CSM_STATE_KEY = 'csm';

export const csmBookQueryKey = (csmUserId: string | null) => [CSM_STATE_KEY, 'book', csmUserId] as const;

export const csmCatalogQueryKey = () => [CSM_STATE_KEY, 'catalog'] as const;

export const csmOwnersQueryKey = () => [CSM_STATE_KEY, 'owners'] as const;

export const cspV2GateQueryKey = (organizationId: string | null) =>
  [CSM_STATE_KEY, 'csp-v2-gate', organizationId] as const;

// Omitting csm_user_id asks for the whole team.
export const getCsmBookOfBusiness = async (csmUserId?: string | null): Promise<CsmBookOfBusiness> => {
  const response = await api.get<CsmBookOfBusiness>(`${API_PREFIX}/csm/book-of-business`, {
    params: csmUserId ? { csm_user_id: csmUserId } : undefined,
  });
  return response.data;
};

export const getCsmCatalog = async (): Promise<CsmCatalogSignal[]> => {
  const response = await api.get<CsmCatalogSignal[]>(`${API_PREFIX}/csm/catalog`);
  return response.data;
};

// Users flagged is_csm in PropelAuth: the only people who can be chosen as a CSM owner.
export const getCsmOwners = async (): Promise<AssigneesListResponse> => {
  const response = await api.get<AssigneesListResponse>(`${API_PREFIX}/csm/owners`);
  return response.data;
};

// Rollout gate for CSP v2 changes outside the CSP pages. Any admin may read it; the CSP pages
// themselves are covered by the can_view_csm_workspace permission and do not use it.
export const getCspV2Gate = async (organizationId?: string | null): Promise<CspV2Gate> => {
  const response = await api.get<CspV2Gate>(`${API_PREFIX}/csp-v2/gate`, {
    params: organizationId ? { organization_id: organizationId } : undefined,
  });
  return response.data;
};
